import React from 'react';
import { Link } from "react-router-dom";
import classNames from 'classnames';

import { Button } from "../Button";
import { Arrow } from "../../assets/icons";

import './styles.scss';

type ControlsProps = {
  handlePrev: () => void,
  handleNext: () => void,
  // resetSelection: (a:boolean) => void,
  currentIndex?: number,
  lastItemIndex?: number,
}

export const Controls: React.FC<ControlsProps> = ({
  handlePrev,
  handleNext,
  currentIndex,
  lastItemIndex,
  // resetSelection,
}) => {
  const handleNextClick = () => {
    handleNext();
    // resetSelection(true);
  }

  return (
    <div className={classNames("Controls")}>
      <Button
        className={"Back" || ''}
        isDisabled={currentIndex === 0}
        onClick={handlePrev}>
        <Arrow className="Arrow Left"/>
      </Button>
      {currentIndex === lastItemIndex ?
        <Link to="/topic/land-nature">
          <Button onClick={handleNext}>
            <Arrow className="Arrow Right"/>
          </Button>
        </Link> :
        <Button onClick={handleNextClick}>
          <Arrow className="Arrow Right"/>
        </Button>
      }
    </div>
  )
};
